<template>
  <div class="main">
    <van-form @submit="onSubmit" label-width="80" style="padding: 8px 24px">
      <van-field class="formField" label="日期" v-model="form.DateTime" readonly clickable @click="showPicker = true" placeholder="点击选择日期"/>
      <van-field class="formField" label="类型">
        <template #input>
          <van-radio-group v-model="form.Type" direction="horizontal">
            <van-radio checked-color="#FEB013" name="早班车">早班车</van-radio>
            <van-radio checked-color="#FEB013" name="晚班车">晚班车</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        class="formField"
        :label="form.Type === '早班车' ? '上车地点':'下车地点'"
        v-model="form.Way"
        readonly
        clearable
        placeholder="点击选择地点"
        :rules="[{ required: true }]"
        @click="showWay = true"/>
      <van-field class="formField" label="姓名" v-model="form.Name" readonly />
      <van-field class="formField" label="工号" v-model="form.UserId" readonly />
      <van-field class="formField" label="联系方式 " v-model="form.Phone" clearable :rules="[{ required: true }]" />
      <van-field class="formField" label="司机" v-model="form.DName" readonly clickable placeholder="点击选择司机" :rules="[{ required: true }]" @click="showUser = true"/>
      <van-field class="formField" label="工号" v-model="form.DriverId" readonly placeholder="自动填写"/>
      <van-field
        class="formField"
        v-model="form.Message"
        rows="3"
        autosize
        label="原因"
        type="textarea"
        maxlength="200"
        placeholder="请输入原因"
        show-word-limit
        :rules="[{ required: true }]"
      />
      <div style="margin-top: 20px;">
        <van-button round block color="#FEB013" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showUser" position="bottom" safe-area-inset-bottom :style="{ height: '65%' }">
      <van-search v-model="searchDriver" show-action placeholder="请输入司机姓名" @search="searchUser">
        <template #action>
          <div @click="searchUser">搜索</div>
        </template>
      </van-search>
      <van-radio-group v-model="form.DName">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in driver_list"
            clickable
            :key="index"
            :title="item.Name + ' ' + item.CarNum"
            @click="toggleName(index)"
          >
          <template #right-icon>
            <van-radio checked-color="#FEB013" :name="item.Name" ref="checkName" />
          </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="showWay" position="bottom" :close-on-click-overlay="false" safe-area-inset-bottom :style="{ height: '90%' }">
      <van-sticky>
        <div class="wayTitle">
          <div style="color: #999999;" @click="showWay = false">取消</div>
          <div style="color: #FEB013;" @click="onWay">确定</div>
        </div>
      </van-sticky>
      <div style="padding: 12px;" v-if="form.Type === '早班车'">
        <baidu-map>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-view class="map"></bm-view>
          <bm-driving
            location="珠海"
            :start="LngLat[0] ? LngLat[0] : WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }"
            :end="endLngLat"
            startCity="珠海"
            endCity="珠海"
            :auto-viewport="true"
            :panel="false"
            :waypoints="LngLat"
            @searchcomplete="searchcomplete"
          >
          </bm-driving>
        </baidu-map>
      </div>
      <van-search v-model="searchValue" show-action placeholder="请输入搜索公交车站关键词" @search="searchSite">
        <template #action>
          <div @click="searchSite">搜索</div>
        </template>
      </van-search>
      <van-radio-group v-model="form.Way">
        <van-cell-group>
          <van-cell
              v-for="(item, index) in way_list"
              clickable
              :key="index"
              :title="item.name"
              @click="toggleWay(index)"
          >
          <template #right-icon>
            <van-radio checked-color="#FEB013" :name="item.name" ref="checkWay" />
          </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
  </div>
</template>
<script src="https://unpkg.com/vue-baidu-map"></script>
<script>
export default {
  data() {
    return {
      form: {
        DateTime: this.$moment().format('YYYY-MM-DD'),
        Type: '早班车',
        Name: '',
        UserId: '',
        Phone: '',
        DName: '',
        DriverId: '',
        Message: '',
        Way: '',
        LngLat: [],
        Distance: 0,
        DStatus: false,
        PStatus: 1
      },
      showPicker: false,
      minDate: this.$moment().add(-7, 'd')._d,
      maxDate: new Date(),
      showUser: false,
      searchDriver: '',
      driver_list: [],
      showWay: false,
      way_list: [],
      searchValue: '',
      wayData: '',
      LngLat: [],
      endLngLat: {}
    }
  },
  mounted() {
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.form.OpenId = this.WXInfo.openid

    this.endLngLat = this.WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }
  },
  methods: {
    onConfirm (value) {
      this.form.DateTime = this.$moment(value).format('YYYY-MM-DD')
      this.showPicker = false
    },
    searchUser () {
      if (this.form.Type === '早班车') {
        this.getWorkDriverInfo(this.searchDriver)
      } else {
        this.getHomeDriverInfo(this.searchDriver)
      }
    },
    async toggleName (index) {
      await this.$refs.checkName[index].toggle()
      this.form.DriverId = this.driver_list[index].UserId
      this.showUser = false
    },
    onWay () {
      this.form.Way = this.wayData
      this.form.LngLat = this.LngLat
      this.showWay = false
    },
    searchcomplete (value) {
      if (value.taxiFare) {
        this.form.Distance = value.taxiFare.distance
      }
    },
    async toggleWay (index) {
      await this.$refs.checkWay[index].toggle()
      this.wayData = this.way_list[index].name
      this.LngLat = [this.way_list[index].location]
    },
    searchSite () {
      this.getSiteList(this.searchValue)
    },
    async havingData(val) {
      let status = false
      let result = await this.$request({
        url: val.Type === '早班车' ? this.$api.getWorkTravelFromPassenger : this.$api.getPassengerByOpenid,
        method: 'GET',
        params: {
          UserId: val.UserId,
          DateTime: val.DateTime
        }
      })
      if (JSON.stringify(result.data) !== "[]") {
        status = true
      }
      return status
    },
    async onSubmit() {
      let having = await this.havingData(this.form)
      if (having) {
        this.$toast('当前日期已有数据，无法提交')
      } else {
        const result = await this.postAbnormal(this.form)
        if (result.success) {
          let message = '补单通知：' +
            '\n\n日期：' + this.form.DateTime +
            '\n类型：' + this.form.Type +
            '\n乘客：' + this.form.Name +
            '\n手机号码：' + this.form.Phone +
            '\n地点：' + this.form.Way + 
            '\n\n有乘客提交补单申请，请确认审核。\n\n' +
            '<a href="https://pinche.jafron.com/work/audit">审核</a>'
          this.postSendMessage(this.form.DriverId, message)
          this.$toast('提交成功')
          this.$router.push('/home')
        } else {
          this.$toast(result.message)
        }
      }
    },
    async getSiteList(value) {
      const result = await this.$request({
        url: this.$api.getBaiDuSiteList,
        method: 'GET',
        params: {
          name: value
        }
      })
      if (result.data.length > 0) {
        let obj = {}
        this.way_list = result.data.reduce((item, next) => {
          obj[next.name] ? '' : obj[next.name] = true && item.push(next)
          return item
        }, [])
      } else {
        this.$toast(result.message)
      }
    },
    postAbnormal(data) {
      return this.$request({
        url: this.$api.postAbnormal,
        method: 'POST',
        params: {
          DateTime: data.DateTime,
          UserId: data.UserId,
          Type: data.Type,
          type: 'create'
        },
        data
      })
    },
    async getWorkDriverInfo(val) {
      const result = await this.$request({
        url: this.$api.getWorkDriverList,
        method: 'GET',
        params: {
          Name: val,
          Role: 'driver',
          Effictive: true,
          Status: true
        }
      })
      if (result.data.length) {
        this.driver_list = result.data
      }
    },
    async getHomeDriverInfo(val) {
      const result = await this.$request({
        url: '/api/Commute/getUserInfo',
        method: 'GET',
        params: {
          Name: val,
          Role: 'driver',
          Work: true
        }
      })
      if (result.data.length) {
        this.driver_list = result.data
      }
    },
    // 发送消息
    async postSendMessage(userid, message) {
      const result = await this.$request({
        url: this.$api.postSendMessageWX,
        method: 'POST',
        data: {
          'touser': userid,
          'msgtype': 'text',
          'agentid': this.$agentid,
          'text': { 'content': message }
        }
      })
      if (!result.success) {
        this.$toast(result.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    height: inherit;
    background-color:#FFFFFF;
  }
  .map {
    width: 100%;
    height: 200px;
  }     
  .formField {
    background-color: #F5F5F5;
    margin: 8px 0;
    border-radius: 4px;
    padding: 12px;
    font-size: 16px;
  }
  .wayTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #F5F5F5;
    padding: 12px;
    background-color: #FFFFFF;
  }  
</style>
